import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import axios from "axios";

import { ChangeUserInfoFormContainer } from "../styled/dashboard";
import { SubmitButton } from "../../../styled/mypage";
import { useModal } from "../../../../../hooks/useModal";

const ChangePwForm = ({}) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state?.user?.data[0]);
  const setting = useSelector((state) => state?.user?.setting);
  const [userPw, setUserPw] = useState({
    prevPassWord: "",
    password: "",
    confirmPassword: "",
  });

  const { modal, openModal, closeModal } = useModal();

  const changePassword = (e) => {
    const { name } = e.target;

    if (!name) return;

    const { value } = e.target;
    setUserPw((data) => ({ ...data, [name]: value }));
  };

  // 비밀번호 체크
  const validatePassword = async () => {
    const fieldLabels = {
      prevPassword: "현재 비밀번호",
      password: "비밀번호",
      confirmPassword: "비밀번호 확인",
    };

    for (let key in fieldLabels) {
      if (textNotExist(fieldLabels[key])) {
        const label = fieldLabels[key] || "";
        toast.error(`${chooseParticle(label, "을를")} 입력해주세요.`);
        return;
      }
    }

    const regPassword = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[#?!@$ %^&*-]).{8,}$/;
    if (!regPassword.test(userPw.password)) {
      toast.error("새 비밀번호 양식이 올바르지 않습니다.");
      return;
    }

    if (userPw.password !== userPw.confirmPassword) {
      toast.error("새 비밀번호가 일치하지 않습니다.");
      return;
    }

    const isUser = await isUserVerify();
    if (isUser) {
      openModal({
        isOpen: true,
        type: "confirmation",
        title: `회원 정보 수정`,
        message: [" 비밀번호를 변경하시겠습니까?"],
        handleConfirm: () => handleSubmitPassword(),
        handleCancel: () => closeModal(),
      });
    }
  };

  const isUserVerify = async () => {
    const url = "/api/signIn";
    const body = {
      id: user.userName,
      pwd: userPw.prevPassWord,
    };

    const res = await axios.post(url, body);

    if (res.data.success === false) {
      toast.error("비밀번호가 일치하지 않습니다.");
      return false;
    } else {
      return true;
    }
  };

  // 비밀번호 변경
  const handleSubmitPassword = async () => {
    const url = "/api/newPasswd";
    const body = {
      mberNo: user.mberNo,
      password: userPw.password,
      username: user.userName,
      offset: 0,
      pageNumber: 0,
      pageSize: 10,
      paged: true,
    };

    try {
      const res = await axios.post(url, body);

      if (res.data.success && res.data.message === "새로운비밀번호 변경완료") {
        toast.success("비밀번호가 변경되었습니다.");
        navigate("/mypage");
      }
    } catch (error) {
      console.log(error);
      toast.error("잠시후 다시 시도해주세요");
    } finally {
      closeModal();
    }
  };

  return (
    <>
      {modal}
      <ChangeUserInfoFormContainer className={setting?.mode}>
        <span>※ 모두 필수 입력 정보입니다.</span>
        <div className="viewer">
          <ul>
            <li>
              <div className="writing_tit ">
                <strong className="tit">현재 비밀번호</strong>
              </div>
              <div className="writing_cont">
                <input
                  type="password"
                  name="prevPassWord"
                  placeholder="현재 비밀번호를 입력해주세요."
                  value={userPw.prevPassWord}
                  onChange={(e) => changePassword(e)}
                  tabIndex={1}
                />
              </div>
            </li>
            <li>
              <div className="writing_tit ">
                <strong className="tit">새 비밀번호</strong>
              </div>
              <div className="writing_cont">
                <input
                  type="password"
                  name="password"
                  placeholder="새 비밀번호 (영문 + 숫자 + 특수문자, 8자리이상)"
                  value={userPw.password}
                  onChange={(e) => changePassword(e)}
                  tabIndex={2}
                />
                {/* <button type="button" name="button">
                <i className="icon_secure"></i>
              </button> */}
              </div>
            </li>
            <li>
              <div className="writing_tit ">
                <strong className="tit">새 비밀번호 확인</strong>
              </div>
              <div className="writing_cont">
                <input
                  type="password"
                  name="confirmPassword"
                  placeholder="새 비밀번호 확인"
                  value={userPw.confirmPassword}
                  onChange={(e) => changePassword(e)}
                  tabIndex={3}
                />
              </div>
            </li>
          </ul>
        </div>
        <SubmitButton>
          <button onClick={validatePassword} tabIndex={4}>
            <span>비밀번호 변경</span>
          </button>
        </SubmitButton>
      </ChangeUserInfoFormContainer>
    </>
  );
};

export default ChangePwForm;
